import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export default function ImageViewer({ open, onClose, src, type = "image" }) {
  if (!src) return null;

  if (type === "image") {
    const slides = [{ src }];

    return (
      <Lightbox
        open={open}
        close={onClose}
        slides={slides}
        carousel={{ finite: slides.length <= 1 }}
        render={{
          buttonPrev: slides.length <= 1 ? () => null : undefined,
          buttonNext: slides.length <= 1 ? () => null : undefined,
        }}
      />
    );
  }

  return (
    <Lightbox
      open={open}
      close={onClose}
      slides={[{}]}
      render={{
        slide: () => (
          <div className="flex items-center justify-center h-full">
            <video
              src={src}
              controls
              autoPlay
              className="max-h-[80vh] max-w-full rounded-lg"
            />
          </div>
        ),
        buttonPrev: () => null,
        buttonNext: () => null,
      }}
    />
  );
}
